module.exports = __webpack_public_path__ + "static/media/bmftr_logo_de.f379bb5e.svg";